import { comicCategories } from "@/mocks/comic";

const quickLinks = [
  { label: "栏目分类", href: "#categories" },
  { label: "热门漫画", href: "#featured" },
  { label: "阅读特色", href: "#features" },
  { label: "精选阅读", href: "#reading" },
  { label: "读者口碑", href: "#testimonials" },
  { label: "常见问题", href: "#faq" },
];

export default function Footer() {
  return (
    <footer className="bg-secondary-100 text-foreground-800">
      <div className="container-paper py-12 md:py-16">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-12">
          {/* 品牌 */}
          <div className="md:col-span-5">
            <a href="#top" className="flex items-center gap-2.5" aria-label="纸盒漫画网">
              <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className="ri-box-3-fill text-xl leading-none" aria-hidden="true"></i>
              </span>
              <span className="flex flex-col leading-none">
                <span className="font-display text-xl text-foreground-950">纸盒漫画网</span>
                <span className="mt-1 text-[10px] tracking-[0.22em] text-foreground-500">
                  PAPER BOX COMICS
                </span>
              </span>
            </a>
            <p className="mt-5 max-w-sm text-sm leading-7 text-foreground-600">
              专注纸质原稿质感与实体书感的复古漫画阅读平台。用泛黄的纸色、印刷的网点与细腻的原稿细节，
              为你还原一页页更耐看的阅读时光。
            </p>
            <div className="mt-6 flex items-center gap-3">
              {["ri-weibo-line", "ri-wechat-line", "ri-bilibili-line", "ri-mail-line"].map(
                (icon, idx) => (
                  <a
                    key={icon}
                    href="#about"
                    aria-label="社交媒体链接"
                    className="flex h-9 w-9 items-center justify-center rounded-md bg-background-50 text-foreground-600 transition-colors hover:bg-primary-500 hover:text-background-50"
                  >
                    <i className={`${icon} text-lg leading-none`} aria-hidden="true"></i>
                  </a>
                ),
              )}
            </div>
          </div>

          {/* 快速导航 */}
          <nav className="md:col-span-3" aria-label="页脚快速导航">
            <h4 className="font-display text-base text-foreground-950">快速导航</h4>
            <ul className="mt-4 space-y-3">
              {quickLinks.map((link) => (
                <li key={link.label}>
                  <a
                    href={link.href}
                    className="inline-block text-sm text-foreground-600 transition-colors hover:text-primary-600"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </nav>

          {/* 热门分类 */}
          <nav className="md:col-span-4" aria-label="热门栏目">
            <h4 className="font-display text-base text-foreground-950">热门栏目</h4>
            <ul className="mt-4 flex flex-wrap gap-2">
              {comicCategories.map((c) => (
                <li key={c.name}>
                  <a
                    href="#categories"
                    className="inline-flex items-center gap-1.5 rounded-full bg-background-50 px-3 py-1.5 text-xs text-foreground-700 transition-colors hover:bg-accent-500 hover:text-background-50"
                  >
                    <i className={`${c.icon} text-sm leading-none`} aria-hidden="true"></i>
                    {c.name}
                  </a>
                </li>
              ))}
            </ul>
          </nav>
        </div>
      </div>

      <div className="border-t border-secondary-300/70">
        <div className="container-paper flex flex-col items-center justify-between gap-2 py-5 text-xs text-foreground-500 sm:flex-row">
          <span>© {new Date().getFullYear()} 纸盒漫画网 · 保留所有权利</span>
          <span className="flex items-center gap-1.5">
            <i className="ri-open-source-line text-sm leading-none" aria-hidden="true"></i>
            用心还原每一页纸质漫画
          </span>
        </div>
      </div>
    </footer>
  );
}